import { useParams } from "react-router-dom";
import { SharedInterfaceMonthlyReports } from "./sharedInterface";
import { useEffect } from "react";
import {
  monthlyReportsListByCompanyAsync,
  selectMonthlyReportsListStatus,
} from "../fleetSlice";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";

export type MonthlyReportsTabProps = {
  canGenerateReports: boolean;
  showMonthlyReportsTab: boolean;
};

export const MonthlyReportsTab = ({
  canGenerateReports,
  showMonthlyReportsTab,
}: MonthlyReportsTabProps) => {
  const params = useParams();
  const dispatch = useAppDispatch();
  const monthlyReportsListStatus = useAppSelector(
    selectMonthlyReportsListStatus,
  );
  const company = useAppSelector(selectCompany);

  useEffect(() => {
    if (
      company &&
      showMonthlyReportsTab &&
      monthlyReportsListStatus === "idle"
    ) {
      void dispatch(monthlyReportsListByCompanyAsync(company.uuid));
    }
  }, [dispatch, monthlyReportsListStatus, company, showMonthlyReportsTab]);

  if (params.tab !== "monthly_reports") {
    return;
  }

  return (
    <SharedInterfaceMonthlyReports canGenerateReports={canGenerateReports} />
  );
};
